<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { toast as sonnerToast } from 'vue-sonner';
import { useAccount } from 'dashboard/composables/useAccount';
import Button from 'dashboard/components-next/button/Button.vue';

// Agregado dos SLAs estourados além do teto de toasts individuais
// (useSlaMissedQueue). Uma linha só — compacto de propósito, porque divide o
// canto com os individuais. A contagem chega por prop e o SlaMissedToaster a
// atualiza no lugar (mesmo id no sonner). Fechar por aqui descarta o
// excedente; os alertas seguem no sino.
const props = defineProps({
  count: {
    type: Number,
    required: true,
  },
  toastId: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();
const router = useRouter();
const { accountScopedRoute } = useAccount();

const close = () => {
  sonnerToast.dismiss(props.toastId);
};

// Mesmo destino do sino (AppNavbar#goToNotifications). Fecha explicitamente:
// se a lista já estiver aberta a rota não muda e o watcher não dispararia.
const openNotifications = () => {
  close();
  router.push(accountScopedRoute('notifications_index'));
};
</script>

<template>
  <div
    class="flex w-full items-center gap-2 rounded-lg border border-n-ruby-6 bg-n-ruby-3 px-4 py-2.5"
  >
    <span class="i-lucide-alarm-clock-off size-4 shrink-0 text-n-ruby-11" />
    <p class="m-0 min-w-0 flex-1 truncate text-sm font-medium text-n-ruby-12">
      {{ t('SLA.MISSED_ALERT.OVERFLOW', { count }, count) }}
    </p>
    <Button
      size="xs"
      color="ruby"
      :label="t('SLA.MISSED_ALERT.VIEW_NOTIFICATIONS')"
      type="button"
      @click="openNotifications"
    />
    <button
      v-tooltip.top="{
        content: t('GENERAL.CLOSE'),
        theme: 'tooltip-on-toast',
      }"
      type="button"
      class="-mr-1 flex size-7 shrink-0 items-center justify-center rounded-md text-n-ruby-11 transition-colors hover:bg-n-ruby-4 hover:text-n-ruby-12"
      :aria-label="t('GENERAL.CLOSE')"
      @click="close"
    >
      <span class="i-lucide-x size-4" />
    </button>
  </div>
</template>
